const CLAIMS_PARAM = /claims="([^"]+)"/

export const readAuthenticateHeader = (response: Response): string | null => {
  try {
    return response.headers.get('WWW-Authenticate')
  } catch {
    // Not every Response-like object (mocks, older webviews) exposes headers.
    return null
  }
}

export const extractClaimsChallenge = (wwwAuthenticate: string | null): string | null => {
  if (!wwwAuthenticate) {
    return null
  }

  const encoded = CLAIMS_PARAM.exec(wwwAuthenticate)?.[1]

  if (!encoded) {
    return null
  }

  try {
    const decoded = window.atob(encoded.replace(/-/g, '+').replace(/_/g, '/'))
    JSON.parse(decoded)

    return decoded
  } catch {
    return null
  }
}
